/** @jsx isolateComponent */

import { useQuery } from '@apollo/react-hooks';
import { isolateComponent } from '@zapier/common-utils';
import { UniversalLayout } from '@zapier/universal-layout';

import { useRouter } from 'next/router';
import { useCurrentAccountId } from './useCurrentAccountId';

type UniversalLayoutProps = React.ComponentProps<typeof UniversalLayout>;
type Props = Pick<
  Partial<UniversalLayoutProps>,
  | 'children'
  | 'mainContentId'
  | 'renderFooter'
  | 'renderInfobar'
  | 'renderHeader'
  | 'renderNotifications'
  | 'shouldRenderAlphabetNav'
  | 'shouldRenderSeoLinks'
>;

export const UniversalLayoutContainer = (props: Props) => {
  const currentUrl = useRouter()?.pathname || '';
  const currentAccountId = useCurrentAccountId();
  return (
    <UniversalLayout
      currentAccountId={currentAccountId}
      currentUrl={currentUrl}
      mainContentId={props.mainContentId}
      renderFooter={props.renderFooter}
      renderHeader={props.renderHeader}
      renderInfobar={props.renderInfobar}
      renderNotifications={props.renderNotifications}
      shouldRenderAlphabetNav={props.shouldRenderAlphabetNav}
      shouldRenderSeoLinks={props.shouldRenderSeoLinks}
      useQuery={useQuery}
    >
      {props.children}
    </UniversalLayout>
  );
};
